/**
 * External dependencies
 */
import { pick } from 'lodash';

/**
 * External dependencies
 */
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const cookieMiddleware = store => next => action => {
	const result = next( action );
	const nextState = pick( store.getState(), [ 'user', 'inboxes' ] );

	// Save the cookie for 1 week.
	cookies.set( 'brukHueState', nextState, { path: '/', maxAge: 60 * 60 * 24 * 7 } );

	return result;
};

export default cookieMiddleware;



// WEBPACK FOOTER //
// ./src/store/middlewares/cookieMiddleware.js